export default {
  init: () => undefined,
  configureScope: () => false,
  captureException: () => String
}
